import {Inject, Injectable, NgZone} from '@angular/core';
import {Chat, Contact, IMessengerConnector} from '../types/all.type';
import {log} from '../functions';
import {TelegramService} from '../pages/page-telegram/telegram.service';
import {InterfaceService} from './interface.service';
import {AllService} from './all.service';
import {NotifierWrapService} from './notifier-wrap.service';
import {NotificationService, NotifyCrossData} from './notification.service';
import {IMessage} from './websocket';
import {SettingsService} from './settings.service';
import {Router, RouterOutlet} from '@angular/router';
import {WhatsappService} from '../pages/page-whatsapp/whatsapp.service';
import {VkService} from '../pages/page-vk/vk.service';
import {FellowdeskService} from '../pages/page-fellowdesk/fellowdesk.service';
import packageInfo from '../../../package.json';
import {VkLongPullService} from '../pages/page-vk/vk.longpull.service';
import {Title} from '@angular/platform-browser';
import {CallService} from './call.service';
import {DecimalPipe} from '@angular/common';
import {DcService} from './dc.service';
declare const electron: any;

@Injectable({
  providedIn: 'root'
})
export class AppService {
  title = '';
  saveHistoryCount = 15;
  public version: string = packageInfo.version;
  public productName: string = packageInfo.productName;
  constructor(
    private dcService: DcService,
    private decimalPipe: DecimalPipe,
    private titleService: Title,
    public whatsappService: WhatsappService,
    public callService: CallService,
    private vkService: VkService,
    private zone: NgZone,
    public router: Router,
    public settingsService: SettingsService,
    private notificationService: NotificationService,
    public notifierWrapService: NotifierWrapService,
    public allService: AllService,
    public interfaceService: InterfaceService,
    public vkLongPullService: VkLongPullService,
    public telegramService: TelegramService,
    @Inject('TelegramService2') public telegramService2: TelegramService,
    @Inject('TelegramService3') public telegramService3: TelegramService,
    @Inject('TelegramService4') public telegramService4: TelegramService,
    @Inject('TelegramService5') public telegramService5: TelegramService,
    @Inject('TelegramService6') public telegramService6: TelegramService,
    @Inject('TelegramService7') public telegramService7: TelegramService,
    @Inject('TelegramService8') public telegramService8: TelegramService,
    @Inject('TelegramService9') public telegramService9: TelegramService,
    @Inject('TelegramService10') public telegramService10: TelegramService,
    @Inject('TelegramService11') public telegramService11: TelegramService,
    @Inject('TelegramService12') public telegramService12: TelegramService,
    @Inject('TelegramService13') public telegramService13: TelegramService,
    @Inject('TelegramService14') public telegramService14: TelegramService,
    @Inject('TelegramService15') public telegramService15: TelegramService,
    @Inject('TelegramService16') public telegramService16: TelegramService,
    @Inject('TelegramService17') public telegramService17: TelegramService,
    @Inject('TelegramService18') public telegramService18: TelegramService,
    @Inject('TelegramService19') public telegramService19: TelegramService,
    @Inject('TelegramService20') public telegramService20: TelegramService,
    @Inject('TelegramService21') public telegramService21: TelegramService,
    @Inject('TelegramService22') public telegramService22: TelegramService,
    @Inject('TelegramService23') public telegramService23: TelegramService,
    @Inject('TelegramService24') public telegramService24: TelegramService,
    @Inject('TelegramService25') public telegramService25: TelegramService,
    @Inject('TelegramService26') public telegramService26: TelegramService,
    @Inject('TelegramService27') public telegramService27: TelegramService,
    @Inject('TelegramService28') public telegramService28: TelegramService,
    @Inject('TelegramService29') public telegramService29: TelegramService,
    @Inject('TelegramService30') public telegramService30: TelegramService,
    @Inject('TelegramService31') public telegramService31: TelegramService,
    @Inject('TelegramService32') public telegramService32: TelegramService,
    @Inject('TelegramService33') public telegramService33: TelegramService,
    @Inject('TelegramService34') public telegramService34: TelegramService,
    @Inject('TelegramService35') public telegramService35: TelegramService,
    @Inject('TelegramService36') public telegramService36: TelegramService,
    @Inject('TelegramService37') public telegramService37: TelegramService,
    @Inject('TelegramService38') public telegramService38: TelegramService,
    @Inject('TelegramService39') public telegramService39: TelegramService,
    @Inject('TelegramService40') public telegramService40: TelegramService,
    @Inject('TelegramService41') public telegramService41: TelegramService,
    @Inject('TelegramService42') public telegramService42: TelegramService,
    @Inject('TelegramService43') public telegramService43: TelegramService,
    @Inject('TelegramService44') public telegramService44: TelegramService,
    @Inject('TelegramService45') public telegramService45: TelegramService,
    @Inject('TelegramService46') public telegramService46: TelegramService,
    @Inject('TelegramService47') public telegramService47: TelegramService,
    @Inject('TelegramService48') public telegramService48: TelegramService,
    @Inject('TelegramService49') public telegramService49: TelegramService,
    @Inject('TelegramService50') public telegramService50: TelegramService,
    @Inject('TelegramService51') public telegramService51: TelegramService,
    @Inject('TelegramService52') public telegramService52: TelegramService,
    @Inject('TelegramService53') public telegramService53: TelegramService,
    @Inject('TelegramService54') public telegramService54: TelegramService,
    @Inject('TelegramService55') public telegramService55: TelegramService,
    @Inject('TelegramService56') public telegramService56: TelegramService,
    @Inject('TelegramService57') public telegramService57: TelegramService,
    @Inject('TelegramService58') public telegramService58: TelegramService,
    @Inject('TelegramService59') public telegramService59: TelegramService,
    @Inject('TelegramService60') public telegramService60: TelegramService,
    public fellowdeskService: FellowdeskService,
  ) {

    this.titleService.setTitle(this.productName + ' ' + this.version);
    /*    setInterval(() => {
          log(this.gsPlayer.getState(), this.wrapPlayer.currentFile, this.wrapPlayer.player);
        }, 1000)*/
    this.openNotificationChat(false);

    this.allService.wsService.status.subscribe((status) => {
      this.dcService.detectChangesConnect$.next();
    });

    this.whatsappService.wsService.status.subscribe((status) => {
      this.dcService.detectChangesConnect$.next();
    });
    this.fellowdeskService.status$.subscribe((status) => {
      this.dcService.detectChangesConnect$.next();
    });
    // @ts-ignore
    // Android focus/active app event
    window.appResumeEvent = new Event('appresume');
    window.addEventListener('appresume', this.openNotificationChat, false);
    ///
    // this.routeLastUrl();
    try {
      electron.ipcRenderer.on('location.href', (event, clickUrl) => {
        this.router.navigate([clickUrl]);
      });
    } catch (e) {}
    try {
      electron.ipcRenderer.on('scroll.chat.bottom', (event, timeout: number) => {
        setTimeout(() => {
          this.interfaceService.scrollChat$.next();
        }, timeout);
      });
    } catch (e) {}
    try {
      electron.ipcRenderer.on('chat.open', (event, argument: NotifyCrossData) => {
        log('chat.open');
        this.openChat(argument.chatId, argument.path);
      });
    } catch (e) {}
    if (this.vkService.isAuth) {
      this.vkLongPullService.initPullServer$.next();
    }
    this.allService.wsService.on<IMessage>('new_message').subscribe((data) => {
      if (!this.settingsService.arConfig?.message_show?.value) {
        return;
      }

      // log('new_message')
      // alert(data?.mute_until);
      // Сохраняем сообщение в storage
      const Service = this.getServiceFromType(data.path);
      if (Service) {
        this.callService.replaceCallMessage(data.new_message, Service, true);
        if (Service.openChatId === data.new_message?.chat_id) {
          if (Service.arTyping?.length > 0) {
            Service.arTyping = [];
            this.dcService.detectChanges$.next('chat-show');
            this.dcService.detectChanges$.next('messages-scroll');
          }
        } else {
          data.new_message.show = true;
          // TODO скорее всего тут задваивает
          Service.arLocalHistory[data.new_message.chat_id] = Service.arLocalHistory[data.new_message.chat_id] || [];
          const arHistory = Service.arLocalHistory[data.new_message.chat_id];
          arHistory.push(data.new_message);
          Service.setLocalHistory$.next({
            id: data.new_message.chat_id,
            arHistory: arHistory.slice(-this.saveHistoryCount)
          });
        }
      }

      if (!data?.mute_until && !data.new_message.out) {
        const text = this.settingsService.arConfig?.message_show_text?.value
          ? data.new_message?.text?.replace(/(<([^>]+)>)/gi, '') ||
          data.new_message?.text_list?.replace(/(<([^>]+)>)/gi, '')
          : 'Текст сообщения скрыт';
        // TODO
        const title = data.new_message?.name?.first + ' ' + data.new_message?.name?.last;
        const clickUrl = `/${data.path}/chat/${data.new_message.chat_id}`;
        // let event = new Event("window.focus", {bubbles: true}); // (2)
        // document.dispatchEvent(event);
        const currentTime = new Date().getTime() / 1000;
        // alert(vkAndroidLastTime + " - " + currentTime + " - "  + data.path);

        const vkAndroidLastTime = this.allService.getCookie('vk_ts_android_last_time');
        const arDisable = [];
        if (data.path !== 'vk' || !vkAndroidLastTime || parseInt(vkAndroidLastTime, 10) < currentTime - 300) {
          arDisable.push('android');
        }
        if (this.allService._openChatId !== data.new_message.chat_id) {
          this.notificationService
            .push(
              {
                title,
                text,
                clickUrl,
                chatId: data.new_message.chat_id,
                chatType: data.new_message.chat_type,
                path: data.path,
                avatar: data.new_message?.avatar,
                urgency: 'critical',
                noSound: !this.settingsService.arConfig?.message_sound?.value,
                subtitle: 'Новое сообщение'
              },
              arDisable
            )
            .subscribe((res: NotifyCrossData) => {
              // log('data', res);
              if (res?.chatId) {
                this.openChat(res.chatId, res.path);
                setTimeout(() => {
                  this.interfaceService.focusTextArea$.next(true);
                }, 500);
              } else if (res?.clickUrl) {
                this.router.navigate([res.clickUrl]);
              }
            });
        } else {
          this.notifierWrapService.onMessagePlay();
        }

        // log('new_message notif');
      }
    });
  }
  openChat(chat: number | string | Chat, path: string | IMessengerConnector, force = false): void {
    // TODO
    delete this.interfaceService.showDetailInfo;

    log('Open chat', typeof chat, chat, path);
    let Service;

    if (typeof path === 'string') {
      path = path.trim();
      Service = this.getServiceFromType(path);
    } else {
      Service = path;
    }
    if (Service) {
      // this.allService.textAreaPosition = Service.message?.length - 1;
      let arChat;
      if (typeof chat !== 'object') {
        arChat = this.allService.arChat?.find((v) => v.id === chat);
        // TODO если нет в списке чатов прописать (Дописал)
        if (!arChat) {
          arChat = {id: chat, service_type: Service.type};
        }
        log('Open chat from no object');
      } else {
        arChat = chat;
      }
      if (arChat?.id) {
        // Скроллим если уже открыт этот чат
        if (
          false &&
          // TODO проверять еще и сервис тайп
          this.allService._openChatId === arChat.id && !force
        ) {
          this.interfaceService.scrollChat$.next();
          return;
        }
        log('Chat found', arChat.id);
        Service.openChat = arChat;
        Service._openChatId = arChat.id;
        if (
          true ||
          // TODO проверять еще и сервис тайп (this.allService._openChatId !== arChat.id) ||
          force
        ) {
          this.allService._openChatId = arChat.id;
          log('Open interfaceService.openChat$', { chat: arChat, Service });
          this.interfaceService.openChat$.next({ chat: arChat, Service });
        }
        this.allService.isCloseChat = false;

      } else {
        this.notifierWrapService.notify('error', 'Error: chat not found: ' + chat);
      }
      if (!this.interfaceService.initTabsInput) {
        setTimeout(() => {
          this.interfaceService.initTabsInput = true;
        }, 6000);
      }
    } else {
      this.notifierWrapService.notify('error', 'Error: service not found: ' + path);
    }
  }
  stringToHslColor(str: string | number, s = 50, l = 35): string {
    const strReverce = str?.toString().split('')?.reverse()?.join('');
    let hash: any = 0;
    for (let i = 0; i < strReverce?.toString()?.length; i++) {
      hash = strReverce.charCodeAt(i) + ((hash << 5) - hash);
    }

    const h = hash % 360;
    return 'hsl(' + h + ', ' + s + '%, ' + l + '%)';
  }
  intToRGBColor(value, s = 70, l = 30) {
    const blue = Math.floor(value % 256);
    const green = Math.floor((value / 256) % 256);
    const red = Math.floor((value / 256 / 256) % 256);
    return 'rgb(' + red + ',' + green + ',' + blue + ')';
  }
  chatSort(array: any): Chat[] {
    return array.sort((a: any, b: any) => {
      if (a.is_support) { return -1; }
      if (b.is_support) { return 1; }
      if (b.is_pinned) { return 1; }
      const aValue = a.last_message?.time;
      const bValue = b.last_message?.time;

      if (!bValue) { return -1; }
      return aValue > bValue ? -1 : bValue > aValue ? 1 : 0;
    });
  }
  public openNotificationChat = (evt) => {
    const path = this.allService.getCookie('NOTIFICATION_PATH');
    const id = this.allService.getCookie('NOTIFICATION_CHAT_ID');
    if (path) {
      this.openChat(id, path);
      // this.router.navigate([NOTIFICATION_URL]);
      this.allService.setCookie('NOTIFICATION_URL', null, { expires: -1 });
      this.allService.setCookie('NOTIFICATION_CHAT_ID', null, { expires: -1 });
      this.allService.setCookie('NOTIFICATION_PATH', null, { expires: -1 });
      return true;
    }
  }
  getServiceFromType(type: string): IMessengerConnector | false {
    switch (type) {
      // TODO multi account
      case 'telegram':
        return this.telegramService;
      case 'telegram|2':
        return this.telegramService2;
      case 'telegram|3':
        return this.telegramService3;
      case 'telegram|4':
        return this.telegramService4;
      case 'telegram|5':
        return this.telegramService5;
      case 'telegram|6':
        return this.telegramService6;
      case 'telegram|7':
        return this.telegramService7;
      case 'telegram|8':
        return this.telegramService8;
      case 'telegram|9':
        return this.telegramService9;
      case 'telegram|10':
        return this.telegramService10;
      case 'telegram|11':
        return this.telegramService11;
      case 'telegram|12':
        return this.telegramService12;
      case 'telegram|13':
        return this.telegramService13;
      case 'telegram|14':
        return this.telegramService14;
      case 'telegram|15':
        return this.telegramService15;
      case 'telegram|16':
        return this.telegramService16;
      case 'telegram|17':
        return this.telegramService17;
      case 'telegram|18':
        return this.telegramService18;
      case 'telegram|19':
        return this.telegramService19;
      case 'telegram|20':
        return this.telegramService20;
      case 'telegram|21':
        return this.telegramService21;
      case 'telegram|22':
        return this.telegramService22;
      case 'telegram|23':
        return this.telegramService23;
      case 'telegram|24':
        return this.telegramService24;
      case 'telegram|25':
        return this.telegramService25;
      case 'telegram|26':
        return this.telegramService26;
      case 'telegram|27':
        return this.telegramService27;
      case 'telegram|28':
        return this.telegramService28;
      case 'telegram|29':
        return this.telegramService29;
      case 'telegram|30':
        return this.telegramService30;
      case 'telegram|31':
        return this.telegramService31;
      case 'telegram|32':
        return this.telegramService32;
      case 'telegram|33':
        return this.telegramService33;
      case 'telegram|34':
        return this.telegramService34;
      case 'telegram|35':
        return this.telegramService35;
      case 'telegram|36':
        return this.telegramService36;
      case 'telegram|37':
        return this.telegramService37;
      case 'telegram|38':
        return this.telegramService38;
      case 'telegram|39':
        return this.telegramService39;
      case 'telegram|40':
        return this.telegramService40;
      case 'telegram|41':
        return this.telegramService41;
      case 'telegram|42':
        return this.telegramService42;
      case 'telegram|43':
        return this.telegramService43;
      case 'telegram|44':
        return this.telegramService44;
      case 'telegram|45':
        return this.telegramService45;
      case 'telegram|46':
        return this.telegramService46;
      case 'telegram|47':
        return this.telegramService47;
      case 'telegram|48':
        return this.telegramService48;
      case 'telegram|49':
        return this.telegramService49;
      case 'telegram|50':
        return this.telegramService50;
      case 'telegram|51':
        return this.telegramService51;
      case 'telegram|52':
        return this.telegramService52;
      case 'telegram|53':
        return this.telegramService53;
      case 'telegram|54':
        return this.telegramService54;
      case 'telegram|55':
        return this.telegramService55;
      case 'telegram|56':
        return this.telegramService56;
      case 'telegram|57':
        return this.telegramService57;
      case 'telegram|58':
        return this.telegramService58;
      case 'telegram|59':
        return this.telegramService59;
      case 'telegram|60':
        return this.telegramService60;
      case 'whatsapp':
        return this.whatsappService;
      case 'vk':
        return this.vkService;
      case 'fellowdesk':
        return this.fellowdeskService;

      default:
        return false;
    }
  }
  onlineSort(array: Contact[]): Contact[] {
    return array.sort((a: any, b: any) => {
      const aValue = a.last_seen?.time;
      const bValue = b.last_seen?.time;

      if (b.online) { return 1; }
      if (!bValue) { return -1; }
      return aValue > bValue ? -1 : bValue > aValue ? 1 : 0;
    });
  }
  arSort(array: any, args): any {
    return array.sort((a: any, b: any) => {
      const key = args.replace('-', '');
      const aValue = a[key];
      const bValue = b[key];
      if (!bValue) { return -1; }
      if (args.indexOf('-') === -1) { return aValue > bValue ? 1 : bValue > aValue ? -1 : 0; }
      else { return aValue > bValue ? -1 : bValue > aValue ? 1 : 0; }
    });
  }
  prepareRoute(outlet: RouterOutlet) {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData.animation;
  }
  bytesToSize(bytes: number): string {
    if (bytes === 0) { return '0 Byte'; }
    const sizes = ['Байт', 'Кб', 'Мб', 'Гб', 'Тб'];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return this.decimalPipe.transform(bytes / Math.pow(1024, i), '1.0-0') + ' ' + sizes[i];
  }
  declOfNum(num: number, titles): string {
    const cases: number[] = [2, 0, 1, 1, 1, 2];
    const title: string = titles[num % 100 > 4 && num % 100 < 20 ? 2 : cases[num % 10 < 5 ? num % 10 : 5]];
    const numberFormat = this.decimalPipe.transform(num);
    if (title.indexOf('#') !== -1) {
      return title.replace('#', numberFormat);
    }
    return `${title}`;
  }
}
